import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { Container, ContentWithPaddingXl } from "../includes/Layouts.js";
import {
  SectionHeading,
} from "includes/Heading";

import { SectionDescription } from "includes/Typography";
import PaxIcon from "images/pax.svg";
import LugIcon from "images/suitcase.svg";
import HandbagIcon from "images/handbag.svg";
const HeadingContainer = tw.div``;
const Heading = tw(SectionHeading)``;
const Description = tw(SectionDescription)`mx-auto text-center`;
const Cards = tw.div`flex flex-wrap flex-row justify-center sm:max-w-2xl lg:max-w-5xl mx-auto`;
const Card = tw.div`mt-24 w-full sm:w-1/2 lg:w-1/3 flex flex-col items-center`;
const CardImage = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`w-64 h-32 bg-contain bg-no-repeat bg-center rounded`}
`;
const CardContent = styled.div`
  ${tw`flex flex-col items-center mt-6`}
  .position {
    ${tw`uppercase font-bold tracking-widest text-xs text-primary-500`}
  }
  .name {
    ${tw`mt-1 text-xl font-medium text-gray-900`}
  9
`;

const CardLinks = styled.div`
  ${tw`mt-6 flex`}
  .link {
    ${tw`mr-8 last:mr-0 text-gray-400 hocus:text-primary-500 transition duration-300`}
    .icon {
      ${tw`fill-current w-6 h-6`}
    }
  }
`;

export default class Fleets extends React.Component {

  title = "";
  description = "";
  fleets = [];

  constructor(props) {
    super(props);
    this.fleets = props.fleetsData;
    this.title = props.fieldData.title;
  }

  render() {
    return (
        <Container className="fleet-wrapper">
          <ContentWithPaddingXl>
            <HeadingContainer>
              {this.title && <Heading>{this.title}</Heading>}
              {this.description && <Description>{this.description}</Description>}
            </HeadingContainer>
            <Cards>
              {this.fleets.map((fleet, index) => (
                  <Card key={index}>
                    <CardImage imageSrc={fleet.image} />
                    <CardContent>
                      <span className="name">{fleet.name}</span>
                      <CardLinks className="fleetInfo">
                        <img src={PaxIcon} alt=""/>
                        {fleet.pax}
                        <img src={LugIcon}  alt="" />
                        {fleet.lug}
                        <img src={HandbagIcon}  alt="" />
                        {fleet.hand}
                      </CardLinks>
                    </CardContent>
                  </Card>
              ))}
            </Cards>
          </ContentWithPaddingXl>
        </Container>
    );
  }
}
